import { Message, MessageTranslator } from '@oneflowab/pomes';

import { composeValidators, maxLength } from 'forms/validators';
import Field from 'components/field';
import TextField from 'components/text-field';
import { TAX_MAX_LENGTH } from 'components/contract-boxes/product-table-box/constants';

import style from './tax-display.module.scss';

type Props = {
  message: MessageTranslator;
};

export const TaxDisplay = ({ message }: Props) => {
  const taxDisplayValidations = composeValidators(
    maxLength({
      message,
      field: 'taxDisplay',
      customMessage: message({
        id: 'Maximum {maxLength} characters allowed.',
        comment: 'Validation message for price price affix validation.',
        values: {
          maxLength: TAX_MAX_LENGTH,
        },
      }),
      maxLength: TAX_MAX_LENGTH,
    }),
  );

  return (
    <div className={style.TaxDisplayContainer}>
      <div className={style.TaxDisplayTitle}>
        <Message id="Tax Display" comment="Tax Display" />
      </div>
      <div className={style.TaxDisplayHelperText}>
        <Message
          id="Set how the tax name is displayed in this column. The tax rate is set on the product line."
          comment="Text to display when tax display is enabled"
        />
      </div>
      <Field
        validate={taxDisplayValidations}
        placeholder={message({ id: 'e.g., Tax', comment: 'Placeholder for tax display.' })}
        name="taxDisplay"
        component={TextField}
        autoComplete="off"
        customClass={style.TaxDisplayTextField}
      />
    </div>
  );
};
